import '../../helpers/browserLocalStorage';
import * as React from "react";
import { createBrowserRouter, Route, RouteObject, RouterProvider } from "react-router-dom";
import AppErrorBoundary from "./components/AppErrorBoundary";
import { patchRouterBackUrl } from "./helpers/patchRouterBackUrl";
import Content, { Props as ContextProps, RouteItem } from "./components/Content";
import AppContext, { AppContextType } from "./AppContext";
import './App.scss';

type Props = ContextProps & {
  baseUrl: string,
  additionalRoutes?: RouteObject[],
  // renderAdditionalRoutes?: () => JSX.Element,
  routes: RouteItem[],
};

export default function App(props: Props) {
  const {
    baseUrl,
    // renderAdditionalRoutes,
    additionalRoutes,
    routes,
    menu,
    defaultRouteUrl,
    renderRouter,
    renderSidebarFooter,
    getSidebarContext,
  } = props;

  const context: AppContextType = React.useMemo(() => ({
    setFullHeight: (isFullHeight) => {
      document.documentElement.classList[isFullHeight ? 'add' : 'remove']('fullHeight');
    },
  }), []);

  const router = React.useMemo(() => patchRouterBackUrl(createBrowserRouter([
    ...(additionalRoutes || []),
    {
      path:     '/',
      element:  (
                  <Content
                    menu={menu}
                    renderSidebarFooter={renderSidebarFooter}
                    getSidebarContext={getSidebarContext}
                    defaultRouteUrl={defaultRouteUrl}
                    renderRouter={renderRouter}
                  />
                ),
      children: routes.map(r => ({
        path: r.path,
        lazy: () => r.component().then(({ default: Component }: any) => ({ Component })),
      })),
      errorElement: <AppErrorBoundary />
    },
  ], { basename: '/' + baseUrl })), []);

  return (
    <AppContext.Provider value={context}>
      <RouterProvider router={router} />
    </AppContext.Provider>
  );
}
